import { Icon, Spinner, SpinnerSize } from "@fluentui/react"
import { useEffect, useRef, useState } from "react";
import styles from './PodStatusSpinner.module.scss';

export enum PodStatusSpinnerState { loading, success, failure };

interface Props {
  state: PodStatusSpinnerState,
}

const PodStatusSpinner = ({state}: Props) => {
  const [isVisible, setIsVisible] = useState(true);
  const transitionTimeout = useRef<number>();

  useEffect(() => {
    if (state !== PodStatusSpinnerState.loading) {
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 1500);
    } else {
      setIsVisible(true);
    }

    return clearTimeout(transitionTimeout.current);
  }, [state]);

  const stateClass = [styles.isLoading, styles.isSuccess, styles.isFailure][state as number];
  
  return (
    <div className={`${styles.spinnerGrid} ${stateClass} ${!isVisible && styles.fadeOut}`}>
      <Spinner size={SpinnerSize.small} className={styles.loadingSpinner}/>
      <Icon iconName="CheckMark" className={styles.successIcon} />
      <Icon iconName="Cancel" className={styles.failureIcon} />
    </div>
  );
}

export default PodStatusSpinner;